import { ConversationTrainingLabelSchema } from "@redotech/redo-support-common/conversation-training-label/conversation-training-label-definition";
import * as z from "zod";

export const getConversationTrainingLabelsForTeam = {
  name: "getConversationTrainingLabelsForTeam" as const,
  input: z.object({ trainingSetId: z.string() }),
  output: z.array(ConversationTrainingLabelSchema),
};
